import React from 'react';

const Logo = ({ size = "medium" }) => {
  const sizeClasses = {
    small: "w-8 h-8",
    medium: "w-12 h-12", 
    large: "w-16 h-16"
  };

  return (
    <div className={`${sizeClasses[size]} relative`}>
      <svg viewBox="0 0 64 64" className="w-full h-full">
        <defs>
          <linearGradient id="circuitGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#dc2626" />
            <stop offset="100%" stopColor="#ea580c" />
          </linearGradient>
        </defs>
        
        {/* Circuit board pattern */}
        <g opacity="0.8">
          <rect x="16" y="16" width="32" height="4" fill="url(#circuitGrad)" rx="1" />
          <rect x="30" y="20" width="4" height="28" fill="url(#circuitGrad)" rx="1" />
          <rect x="16" y="44" width="32" height="4" fill="url(#circuitGrad)" rx="1" />
        </g>
        
        {/* Connection points */}
        <circle cx="20" cy="18" r="3" fill="#fbbf24" />
        <circle cx="44" cy="18" r="3" fill="#fbbf24" />
        <circle cx="32" cy="32" r="4" fill="white" />
        <circle cx="20" cy="46" r="3" fill="#fbbf24" />
        <circle cx="44" cy="46" r="3" fill="#fbbf24" />
        
        {/* T in center */}
        <text x="32" y="36" textAnchor="middle" fill="#dc2626" fontSize="8" fontWeight="bold">T</text>
      </svg>
    </div>
  );
};

export default Logo;
